import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../Button/Button";
import {
  selectCrmLeadsFilters,
  setCrmLeadsDealRoomNumber,
} from "../../../redux/slices/filterSlice";

interface DealRoomNumberFilterProps {
  onClose: () => void;
}

const DealRoomNumberFilter = ({ onClose }: DealRoomNumberFilterProps) => {
  const dispatch = useDispatch();
  const dealRoomNumber = useSelector(selectCrmLeadsFilters)?.dealRoomNumber;

  const [roomNumber, setRoomNumber] = useState<string>(
    (dealRoomNumber?.value as string) || ""
  );

  const handleApply = () => {
    const trimmed = roomNumber.trim();
    dispatch(
      setCrmLeadsDealRoomNumber({ value: trimmed, displayValue: trimmed })
    );
    onClose();
  };

  const isApplyDisabled =
    roomNumber.trim() === ((dealRoomNumber?.value as string) || "");

  return (
    <div className="flex flex-col h-[92vh] overflow-hidden">
      <div className="flex-1 min-h-0 overflow-y-auto px-3 py-4">
        <input
          type="text"
          value={roomNumber}
          onChange={(e) => setRoomNumber(e.target.value)}
          placeholder="Enter room number"
          className="w-full px-3 py-2 text-sm rounded-lg border border-border-gray dark:border-border-gray-dk outline-none text-heading-text dark:text-heading-text-dk placeholder:text-gray-placeholder dark:placeholder:text-gray-placeholder-dk"
        />
      </div>

      <div className="flex justify-end gap-2 mt-4 px-3 pb-2 shrink-0">
        <Button
          innerText="Cancel"
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
          onClick={onClose}
        />
        <Button
          innerText="Apply"
          disabled={isApplyDisabled}
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
          onClick={handleApply}
        />
      </div>
    </div>
  );
};

export default DealRoomNumberFilter;
